import type { Pillar } from 'chery-contracts';

/**
 * Pillar and division constants for the browser — the very same values the service uses (they live in
 * `chery-kpi-engine`). Colours are applied through the Tailwind `pillar-*` tokens (CSS variables in
 * `index.css`), so they follow the theme; the hex values in `PILLAR_META` stay for print and charts.
 */
export { DIVISION_META, DIVISIONS, divisionBelongsTo, PILLAR_META, PILLARS } from 'chery-kpi-engine';

/** The Tailwind class names for one pillar. Spelled out in full so Tailwind's scanner keeps them. */
export interface PillarClasses {
  text: string;
  band: string;
  border: string;
  dot: string;
}

export const PILLAR_CLASSES: Readonly<Record<Pillar, PillarClasses>> = {
  GET: { text: 'text-pillar-get', band: 'bg-pillar-get-tint', border: 'border-pillar-get-line', dot: 'bg-pillar-get' },
  SELL: { text: 'text-pillar-sell', band: 'bg-pillar-sell-tint', border: 'border-pillar-sell-line', dot: 'bg-pillar-sell' },
  SERVICE: { text: 'text-pillar-service', band: 'bg-pillar-service-tint', border: 'border-pillar-service-line', dot: 'bg-pillar-service' },
  PARTS: { text: 'text-pillar-parts', band: 'bg-pillar-parts-tint', border: 'border-pillar-parts-line', dot: 'bg-pillar-parts' },
  FINANCE: { text: 'text-pillar-finance', band: 'bg-pillar-finance-tint', border: 'border-pillar-finance-line', dot: 'bg-pillar-finance' },
};
